/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsForAzureMcaApplication extends models.ServiceAccountCredentialsBaseForAzureApplication {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsForAzureMcaApplication");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsForAzureMcaApplication.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsForAzureMcaApplication>): ServiceAccountCredentialsForAzureMcaApplication {
        let obj = Object.assign(new ServiceAccountCredentialsForAzureMcaApplication(), model);
        ServiceAccountCredentialsForAzureMcaApplication.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsForAzureMcaApplication>): ServiceAccountCredentialsForAzureMcaApplication {
        if (!model) return null;
        return ServiceAccountCredentialsForAzureMcaApplication.newInstance(<ServiceAccountCredentialsForAzureMcaApplication> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsForAzureMcaApplication) {
        if (!obj) return;

        models.ServiceAccountCredentialsForAzureMcaApplication.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsForAzureMcaApplication): boolean {
        if (models.ServiceAccountCredentialsBaseForAzureApplication.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsForAzureMcaApplication.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
